export default {
	students: (state) => state.students
};



// WEBPACK FOOTER //
// ./sources/app/leaving-monitor/getters.js